import { Typography } from 'modules/Typography';
import { Falcon } from 'modules/macro';
import { ActionsContainer, Header, Trigger } from './styled';
export function SectionHeader(props) {
    const { title, actions } = props;
    return (<Header>
      <Trigger>
        <Typography $fontSize="small" $fontWeight="medium" color="text.100">
          {title}
        </Typography>
        <Falcon $size={11} $color="swatches.gray.500" icon="caret-right" sourceConfig={{ style: 'solid', family: 'classic' }}/>
      </Trigger>
      {actions && <ActionsContainer>{actions}</ActionsContainer>}
    </Header>);
}
